<template>
    <div>
        <div v-if="markdownToHtml === ''">
            <h2>What the customer feels is missing in the box</h2>
            <div v-if="styling !== null && styling.comment !== ''">{{ styling.comment }}</div>
            <div v-else>N/A</div>

            <h2>Customer comment</h2>
            <div v-if="survey !== null && survey.other_to_know !== null && survey.other_to_know !== ''">{{ survey.other_to_know }}</div>
            <div v-else>N/A</div>
        </div>

        <div v-else>
            <div v-if="styling !== null &&  styling.comment !== ''"
                style="margin-bottom: 40px;">
                <h2>What the customer feels is missing in the box</h2>
                <div>{{ styling.comment }}</div>
            </div>
            <div v-html="markdownToHtml"></div>
        </div>
    </div>
  </template>
  
  <script>
  import MarkdownIt from 'markdown-it';
  import Vue from 'vue';

  export default {
    name: 'FeedbackSummaryModal',
    props: {
        summary: {
            type: String,
            default: ""
        },
        survey: {
            type: Object,
            default: null
        },
        styling: {
            type: Object,
            default: null
        }
    },
  
    data () {
    return {
      markdownSummary: '',
      md: new MarkdownIt()
    }
  },

    computed: {
        markdownToHtml() {
            return this.md.render(this.summary);
        }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .pre-wrap {
    white-space: pre-wrap;
  }
  </style>
  
